import React from "react";
import { BsExclamationTriangleFill } from "react-icons/bs";
// import { FaExclamation } from "react-icons/fa";

export const CDKAlertNote2 = ({
  icon = (
    <BsExclamationTriangleFill size={25} className="cdk-alert-note-icon-2" />
  ),
  message,
  color = "white",
  containerStyleMerge,
}) => {
  return (
    <div
      role="alert"
      style={{
        position: "relative",
        borderRadius: "12px",
        color: color,
        // margin: "20px",
        boxShadow: "0px 3px 5px 0px rgba(0,0,0,.25)",
        ...containerStyleMerge,
      }}
      className="px-3 py-3 pr-5 paper-card cdk-alert-note-2"
    >
      <div style={{ position: "absolute", top: 0, right: 0 }}>{icon}</div>
      <div>{message}</div>
    </div>
  );
};
